export default __webpack_public_path__ + "images/bf7f7a6565c3ed54bbb49585a26b92d3.png";